goog.provide("shadow.js.shim.module$src$svg$objects$clock_svg");
goog.provide("module$shadow_js_shim_module$src$svg$objects$clock_svg");
shadow.js.shim.module$src$svg$objects$clock_svg = shadow.js.nativeProvides["src/svg/objects/clock.svg"] = shadow$bridge("src/svg/objects/clock.svg");
module$shadow_js_shim_module$src$svg$objects$clock_svg.default = shadow.js.shim.module$src$svg$objects$clock_svg;
